import { Component, OnInit } from "@angular/core";
import { CurrencyTransform } from "app/helpers/pipes/currencyTransform.pipe";
import { ActivatedRoute } from "@angular/router";
import {
  OpcionesService,
  PanelItemOpcionesVM
} from "../../../infrastructure/services/opciones.service";
import {
  AlertService,
  GrowlType
} from "../../../infrastructure/services/alert.service";
import { SxContextService } from "../../../infrastructure/services/sxContext.service";
import { SuscripcionesService } from "../../../infrastructure/services/suscripciones.service";
import { Currency } from "app/infrastructure/model/interfaces/currency.interface";

@Component({
  templateUrl: "./configurar.currency.component.html"
})
export class CurrencyConfigurationComponent implements OnInit {
  codSistema: string;
  codNegocio: string;
  codProducto: string;
  currencies: Currency[] = [];
  opciones: PanelItemOpcionesVM[];
  opcion: PanelItemOpcionesVM;
  listadoFiltrado: any;
  buscarListado: String = "";
  currencyCelda: string = "";
  fileName: string = "";

  constructor(
    private aRoute: ActivatedRoute,
    private suscripcionService: SuscripcionesService,
    private alertService: AlertService,
    private opcionesService: OpcionesService,
    public sxContextService: SxContextService
  ) {}

  ngOnInit() {
    this.opcionesService.getCurrencies().subscribe(dbCurrencies => {
      this.currencies = dbCurrencies;
    });

    this.aRoute.params.subscribe(params => {
      this.codSistema = params["codsistema"];
      this.codNegocio = params["codnegocio"];
      this.codProducto = params["codproducto"];

      this.opcionesService
        .getByProducto(this.codSistema, this.codNegocio, this.codProducto)
        .then(opciones => {
          this.opciones = opciones;
          this.getCurrenciesFromExcel();
          this.filtrarListado();
        });
    });
  }

  getCurrenciesFromExcel() {
    this.opciones.forEach(op => {
      if (op.currency === undefined || op.currency === null) {
        this.suscripcionService
          .getRules(op.subscriptionCode, this.codSistema)
          .then(rule => {
            this.currencyCelda = rule.header.currencyCode;

            if (
              this.currencyCelda === undefined ||
              this.currencyCelda === null
            ) {
              //ManejarError & set selectbox empty
            }

            this.opcionesService
              .getExcelCurrency(
                op.subscriptionCode,
                this.codSistema,
                this.currencyCelda
              )
              .then(excelCurrency => {
                op.currency = excelCurrency;
              });
          });
      }
    });
  }

  filtrarListado() {
    this.listadoFiltrado = this.opciones.filter(
      item =>
        item.optionNumber
          .toString()
          .toUpperCase()
          .indexOf(this.buscarListado.toUpperCase()) !== -1 ||
        item.codPlan
          .toString()
          .toUpperCase()
          .indexOf(this.buscarListado.toUpperCase()) !== -1 ||
        item.description
          .toString()
          .toUpperCase()
          .indexOf(this.buscarListado.toUpperCase()) !== -1 ||
        item.codProvider
          .toString()
          .toUpperCase()
          .indexOf(this.buscarListado.toUpperCase()) !== -1
    );
  }

  editar(opcion: PanelItemOpcionesVM) {
    this.opcionesService.editarOpcion(opcion).then(data => {
      this.alertService.showGrowl({
        type: GrowlType.SUCCESS,
        body: "CURRENCY_UPDATED_SUCCESS"
      });
    });
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/configuracion/currency/configurar.currency.component.ts